import { translate } from "@/i18n/i18n";
import { formatTime } from "@/lib/utils";
import { PrimedTrainType } from "@ailenax-overlay/shared";
import { FC, useCallback, useEffect, useState } from "react";

interface PrimedProps {
    train: PrimedTrainType;
    offset: number;
}

export const Primed: FC<PrimedProps> = ({ train, offset }) => {
    const [timeRemaining, setTimeRemaining] = useState<number>(0);

    const updateTime = useCallback(() => {
        const now = new Date();
        const totalTime = train.expiresAt.getTime() - train.primedAt.getTime();
        const timeElapsed = now.getTime() - train.primedAt.getTime() - offset;
        setTimeRemaining(~~((totalTime - timeElapsed) / 1000));
    }, [train, offset]);

    useEffect(() => {
        updateTime();
        const interval = setInterval(updateTime, 1000);

        return () => clearInterval(interval);
    }, [updateTime]);
    
    //div className="w-[100%] h-[100%] flex justify-center items-center text-2xl">
    return (
        <div className="w-[100%] h-[100%] px-3 flex flex-row items-center justify-between">
            <div className="z-1 w-75 flex-auto flex flex-col items-stretch justify-center gap-1">
                <div className="text-2xl">
                    { translate("DONO_TRAIN_IS_PRIMED") }
                </div>
                <div className="text-sm">
                    { translate("DONO_TRAIN_START_CONDITION") }
                </div>
            </div>
            <div className="w-25 text-end text-3xl">
                { formatTime(Math.max(0, timeRemaining)) }
            </div>
        </div>
    );
}